import { FC, memo } from 'react';
import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';
import { selectToken } from '../../store/reducers/AuthSlice';
import { useAppSelector } from '../../store/store';

const NotFoundScreenComponent: FC = () => {
  const navigate = useNavigate();
  const token = useAppSelector(selectToken);

  const handleGoHome = () => {
    if (!token) {
      navigate('/login', { replace: true });
      return;
    }

    navigate('/', { replace: true });
  };

  return (
    <Result
      status="404"
      title="404"
      subTitle="Страница не найдена или у вас нет к ней доступа"
      extra={
        <Button type="primary" onClick={handleGoHome}>
          На главную
        </Button>
      }
    />
  );
};

export const NotFoundScreen = memo(NotFoundScreenComponent);
NotFoundScreen.displayName = 'NotFoundScreen';
